import { getSystemIcon, SystemIcon } from '@helpers/icons';
import { withMotionMax } from '@hoc/withMotionMax';
import { useScrollPeek } from '@hooks/useScrollPeek';
import SvgLogo from '@img/logo.svg';
import Searchbox from '@stories/Components/Misc/Forms/Searchbox/Searchbox';
import SkipLink from '@stories/Components/Misc/SkipLink/SkipLink';
import * as React from 'react';
import { useCookies } from 'react-cookie';
import AnnouncementBar from './AnnouncementBar/AnnouncementBar';
import S from './Navigation.styles';
import NavigationLinks from './NavigationLinks/NavigationLinks';
const Navigation = (props) => {
    const cookieName = props.cookieName ?? 'navigation-cookie';
    const [, setCookie] = useCookies([cookieName]);
    const [menuOpen, setMenuOpen] = React.useState(false);
    const [searchOpen, setSearchOpen] = React.useState(false);
    const [searchSuggestionsVisible, setSearchSuggestionsVisible] = React.useState(false);
    const [activeMenu, setActiveMenu] = React.useState(-1);
    const isPeeking = useScrollPeek({ threshold: 100 });
    return (React.createElement(React.Fragment, null,
        React.createElement(S.GlobalStyles, null),
        React.createElement(SkipLink, { type: 'header', translations: props.translations }),
        React.createElement(S.Container, { id: "header", "data-reduced": !isPeeking, "data-menu-open": menuOpen },
            React.createElement(S.Inner, null,
                renderNavigationTabs(false),
                React.createElement(AnnouncementBar, { items: props.announcementItems, translations: props.translations, duration: props.announcementDuration, speed: props.announcementSpeed }),
                React.createElement(S.Main, null,
                    React.createElement(S.Logo, { href: "/", "aria-label": props.translations?.['global.navigation.home'] },
                        React.createElement(SvgLogo, null)),
                    React.createElement(S.CtaWrapper, null,
                        React.createElement(S.CtaLink, { as: "button", onClick: () => {
                                setSearchOpen(!searchOpen);
                                setMenuOpen(false);
                            }, "aria-controls": "nav-search", "aria-expanded": searchOpen, "data-type": props.searchCtaType, "data-mobile": true },
                            React.createElement("span", null,
                                getSystemIcon(SystemIcon.Search),
                                getSystemIcon(SystemIcon.Close)),
                            React.createElement("span", null, searchOpen
                                ? props.translations?.['global.search.close']
                                : props.translations?.['global.search.open'])),
                        React.createElement(S.SearchBoxContainer, { id: "nav-search", "data-open": searchOpen },
                            React.createElement(Searchbox, { ...props.searchbox, idPrefix: "navigation-", translations: props.translations, onSuggestionsVisible: (visible) => setSearchSuggestionsVisible(visible), buttonType: props.searchCtaType, onClear: () => {
                                    setSearchSuggestionsVisible(false);
                                    setSearchOpen(false);
                                } })),
                        props.ctas?.map((cta) => (React.createElement(S.CtaLink, { key: cta.id, href: cta.url, target: cta.target, "data-type": cta.type, "data-style": cta.style, "data-mobile": false },
                            React.createElement("span", null, getSystemIcon(cta.icon ?? SystemIcon.None)),
                            React.createElement("span", null, cta.text)))),
                        React.createElement(S.MenuButton, { onClick: () => {
                                setMenuOpen(!menuOpen);
                                setSearchOpen(false);
                            }, "aria-controls": "main-nav", "aria-expanded": menuOpen, "aria-label": menuOpen
                                ? props.translations?.['global.navigation.close']
                                : props.translations?.['global.navigation.open'] },
                            getSystemIcon(SystemIcon.Menu),
                            getSystemIcon(SystemIcon.Close))),
                    React.createElement(NavigationLinks, { active: activeMenu, links: props.links, setActive: setActiveMenu, translations: props.translations })),
                renderNavigationTabs(true))),
        React.createElement(S.Backdrop, { "aria-label": searchOpen || searchSuggestionsVisible
                ? props.translations?.['global.search.close']
                : props.translations?.['global.navigation.close'], "data-visible": menuOpen || searchOpen || searchSuggestionsVisible || activeMenu !== -1, onClick: () => {
                setMenuOpen(false);
                setSearchOpen(false);
            } })));
    function renderNavigationTabs(mobile) {
        return (React.createElement(S.NavigationTabs, { "data-mobile": !!mobile, role: "tablist" }, props.navigationTabs.map((tab) => (React.createElement(S.NavigationTab, { key: tab.id, href: tab.url, "aria-selected": tab.active, role: "tab", onClick: () => setCookie(cookieName, tab.id, { path: '/', maxAge: 24 * 60 * 60 }) }, tab.text)))));
    }
};
export default withMotionMax(Navigation);
